import React from 'react'
import Head, { PageHead } from '@fs/zion-head'

export default function AuthoritiesAppPageHead({ title, description, canonicalUrl }) {
  return (
    <>
      <PageHead includeHreflang title={title} description={description} url={canonicalUrl} />
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
    </>
  )
}
